import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import TrackImpression from "../../shared/track-impression";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { useHistory } from "react-router-dom";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { getSellerTypeStyle, PLATFORMS, STYLE_COMPONENTS, STYLE_KEYS } from "../../../constants/app-constants";

const BuyWithConfidenceCard = ({cardImage, cardTitle, onClick, showFinanceFirstExperimentCard, btnText, icon, showStraightThroughCard, isLuxuryCar}) => {
    const history = useHistory();
    if (showFinanceFirstExperimentCard) {
        const handleClick = async () => {
            history.push("/financing/get-pre-approval");
            await yieldToMain();
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FF_VOLUME_EXPERIMENT, {
                eventAction: "Finance_card_clicked",
                eventLabel: "Get_pre_approval_CDP_buy_with_confidence"
            });
        };
        const outerStyleName = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.BUY_WITH_CONFIDENCE_CARD, STYLE_KEYS.OUTER_WITH_EXTRAS, isLuxuryCar, false);
        return (
            <div styleName={outerStyleName}>
                <TrackImpression event={{gaName: AU_DESKTOP_EVENTS.FF_VOLUME_EXPERIMENT, data: {eventLabel: "Finance_CDP_buy_with_confidence", eventAction: "Card_viewed"}, properties: {"Card_viewed": "Finance_CDP_buy_with_confidence"}}}>
                    <img src={icon} />
                    <p styleName={"styles.title styles.subtitle"} onClick={handleClick}>{cardTitle}<span onClick={handleClick}>{btnText}</span></p>
                </TrackImpression>
            </div>
        );
    }
    if (showStraightThroughCard) {
        const outerStyleName = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.BUY_WITH_CONFIDENCE_CARD, STYLE_KEYS.OUTER_WITH_EXTRAS, isLuxuryCar, false);
        return (
            <div styleName={outerStyleName}>
                <TrackImpression event={{gaName: AU_DESKTOP_EVENTS.FF_VOLUME_EXPERIMENT, data: {eventLabel: "Finance_CDP_buy_with_confidence", eventAction: "Card_viewed"}, properties: {"Card_viewed": "Finance_CDP_buy_with_confidence"}}}>
                    <img src={icon} />
                    <p styleName={"styles.title styles.stTitle"}>{cardTitle}</p>
                </TrackImpression>
            </div>
        );
    }
    const outerStyleName = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.BUY_WITH_CONFIDENCE_CARD, STYLE_KEYS.OUTER, isLuxuryCar, false);
    return (
        <div styleName={outerStyleName}>
            <LazyImage alt={cardTitle} src={cardImage}  styleName={"styles.buyWithConfidenceImage"}/>
            <p styleName={"styles.title"} onClick={onClick}>{cardTitle}</p>
        </div>
    );
};

BuyWithConfidenceCard.propTypes = {
    cardImage: PropTypes.string,
    btnText: PropTypes.string,
    icon: PropTypes.object,
    showFinanceFirstExperimentCard: PropTypes.bool,
    cardTitle: PropTypes.string,
    onClick: PropTypes.func,
    fullWidth: PropTypes.bool,
    showStraightThroughCard: PropTypes.bool,
    isLuxuryCar: PropTypes.bool
};

export default BuyWithConfidenceCard;
